"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.delComment = exports.addVote = exports.addComment = exports.getItemNews = exports.loadMore = exports.getFeed = exports.resetState = exports.setAllLoaded = exports.updateFeed = exports.deleteCommentFromList = exports.removeMessage = exports.setItemNews = exports.resetNewsItem = exports.getCommentDetails = exports.toggleDeleteCommentModal = exports.toggleNewsFeedModal = exports.makeVote = exports.bindComment = exports.setFeed = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const preloaderSlice_1 = require("./preloaderSlice");
const store_1 = __importDefault(require("../store"));
const initialState = {
    feed: [],
    detailsModalOpen: false,
    deleteModalOpen: false,
    itemNews: {
        content: {
            description: '',
            link: '',
            source: '',
            title: '',
        },
        comments: []
    },
    newsId: null,
    commentId: null,
    allLoaded: false,
};
const newsFeed = toolkit_1.createSlice({
    name: 'newsFeed',
    initialState: initialState,
    reducers: {
        setFeed: (state, action) => {
            state.feed = action.payload;
            return state;
        },
        updateFeed: (state, action) => {
            state.feed = [
                ...state.feed,
                ...action.payload
            ];
            return state;
        },
        setAllLoaded: (state) => {
            state.allLoaded = true;
            return state;
        },
        resetNewsItem: (state) => {
            state.itemNews = initialState.itemNews;
        },
        setItemNews: (state, action) => {
            state.itemNews = action.payload;
            return state;
        },
        bindComment: (state, action) => {
            const { news_id } = action.payload;
            const newsIndex = state.feed.findIndex(n => n.id === news_id);
            if (newsIndex > -1) {
                const commentsCount = parseInt(state.feed[newsIndex].commentsCount);
                state.feed[newsIndex].comments.unshift(action.payload);
                state.itemNews.comments.unshift(action.payload);
                if (state.feed[newsIndex].comments.length >= 4 || state.itemNews.comments.length >= 4 && action.payload.from == null) {
                    state.feed[newsIndex].comments.pop();
                }
                state.feed[newsIndex].commentsCount = (commentsCount + 1);
                state.itemNews.commentsCount = (commentsCount + 1);
            }
            return state;
        },
        makeVote: (state, action) => {
            const { news_id, totalVotes, voted } = action.payload;
            const newsIndex = state.feed.findIndex(n => n.id === news_id);
            if (newsIndex > -1) {
                state.feed[newsIndex].me_voted = voted > 0;
                state.feed[newsIndex].votes = totalVotes;
                state.itemNews.me_voted = voted > 0;
                state.itemNews.votes = totalVotes;
            }
            return state;
        },
        toggleNewsFeedModal: (state) => {
            state.detailsModalOpen = !state.detailsModalOpen;
            return state;
        },
        toggleDeleteCommentModal: (state) => {
            state.deleteModalOpen = !state.deleteModalOpen;
            return state;
        },
        removeMessage: (state) => {
            state.detailsModalOpen = !state.detailsModalOpen;
            return state;
        },
        getCommentDetails: (state, action) => {
            state.commentId = action.payload.commentId;
            state.newsId = action.payload.newsId;
            return state;
        },
        deleteCommentFromList: (state, action) => {
            const msg = action.payload;
            if (state.itemNews) {
                const commentIndex = state.itemNews.comments.findIndex(i => i.id === msg.commentId);
                if (commentIndex > -1) {
                    state.itemNews.comments.splice(commentIndex, 1);
                    state.itemNews.commentsCount = state.itemNews.comments.length;
                }
            }
            return state;
        },
        resetState: (state) => {
            return initialState;
        }
    }
});
_a = newsFeed.actions, exports.setFeed = _a.setFeed, exports.bindComment = _a.bindComment, exports.makeVote = _a.makeVote, exports.toggleNewsFeedModal = _a.toggleNewsFeedModal, exports.toggleDeleteCommentModal = _a.toggleDeleteCommentModal, exports.getCommentDetails = _a.getCommentDetails, exports.resetNewsItem = _a.resetNewsItem, exports.setItemNews = _a.setItemNews, exports.removeMessage = _a.removeMessage, exports.deleteCommentFromList = _a.deleteCommentFromList, exports.updateFeed = _a.updateFeed, exports.setAllLoaded = _a.setAllLoaded, exports.resetState = _a.resetState;
const getFeed = () => async (dispatch) => {
    try {
        dispatch(preloaderSlice_1.showLoader());
        const feed = await api_1.NewsFeed.feed();
        dispatch(exports.setFeed(feed));
        dispatch(preloaderSlice_1.hideLoader());
    }
    catch (e) {
        dispatch(preloaderSlice_1.hideLoader());
    }
};
exports.getFeed = getFeed;
const loadMore = data => async (dispatch) => {
    const { offset } = data;
    const feed = await api_1.NewsFeed.feed({ offset });
    if (!feed.length) {
        return dispatch(exports.setAllLoaded());
    }
    dispatch(exports.updateFeed(feed));
};
exports.loadMore = loadMore;
const getItemNews = data => async (dispatch) => {
    try {
        const itemNews = await store_1.default.getState().newsFeed.feed.find(item => item.id == data.id);
        const comments = await api_1.NewsFeed.getAllComments(data.id, itemNews.commentsCount);
        dispatch(exports.setItemNews(Object.assign(Object.assign({}, itemNews), { comments: comments })));
    }
    catch (e) {
        dispatch(preloaderSlice_1.hideLoader());
    }
};
exports.getItemNews = getItemNews;
const addComment = (props) => async (dispatch) => {
    try {
        const comment = await api_1.NewsFeed.addComment(props);
        dispatch(exports.bindComment(Object.assign(Object.assign({}, comment.data), { news_id: props.news_id, from: props.from })));
    }
    catch (e) {
        return false;
    }
};
exports.addComment = addComment;
const addVote = (props) => async (dispatch) => {
    try {
        const vote = await api_1.NewsFeed.makeVote(props);
        dispatch(exports.makeVote({
            news_id: props.news_id,
            totalVotes: vote.totalVotes,
            voted: props.vote
        }));
    }
    catch (e) {
        return false;
    }
};
exports.addVote = addVote;
const delComment = (status) => async (dispatch) => {
    try {
        if (status) {
            const commentId = store_1.default.getState().newsFeed.commentId;
            const newsId = store_1.default.getState().newsFeed.newsId;
            const payload = await api_1.NewsFeed.deleteComment(newsId, commentId);
            const feed = await api_1.NewsFeed.feed();
            dispatch(exports.setFeed(feed));
            dispatch(exports.deleteCommentFromList({ commentId: commentId, newsId: newsId }));
        }
    }
    catch (e) {
        return false;
    }
};
exports.delComment = delComment;
exports.default = newsFeed.reducer;
